import { render, staticRenderFns } from "./NewMapBoundaryComponent.vue?vue&type=template&id=672e5df0"
import script from "./NewMapBoundaryComponent.vue?vue&type=script&lang=js"
export * from "./NewMapBoundaryComponent.vue?vue&type=script&lang=js"
import style0 from "./NewMapBoundaryComponent.vue?vue&type=style&index=0&id=672e5df0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports